// extracted by mini-css-extract-plugin
module.exports = {"header":"shared-components-Header-Header__header--qZaPk"};